<template>
    <section class="" :style="{ backgroundColor: backgroundColor }">
        <div class="grid grid-cols-12">
            <div class="col-span-12 lg:col-span-5">
                <nuxt-img :src="imageSrc" :alt="imageAlt" width="1211" height="1305"
                    sizes="xs:330px sm:440px md:760px lg:1023px xl:493px 2xl:989px" loading="lazy" format="webp"
                    class="mx-auto" />
            </div>

            <div
                class="lg:col-span-7 col-span-12 2xl:mr-[calc((100vw_-_1280px)_/_2)] xl:px-32 px-6 md:px-16 lg:py-0 py-8">
                <div class="flex flex-col justify-center h-full">
                    <h2 class="text-2xl font-bold text-center md:text-3xl lg:text-3xl xl:text-40 xl:leading-10 font-ww-bold md:text-left">
                        {{ heading }}
                    </h2>
                    <div class="lg:mt-8 mt-4 text-base md:text-lg font-ww-regular !leading-5 xl:pr-16 md:text-left text-center" v-html="description"></div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
const props = defineProps({
    heading: {
        type: String,
        default: "Chocolate Covered Strawberry"
    },
    description: {
        type: String,
        default: `
        This Valentine's Day, fill your mug with our indulgent chocolate covered strawberry coffee and savor the taste and fragrance of heaven. <br><br>
  
        All natural extracts of sweet, sun-ripened, juicy strawberries come alive beneath a blanket of silky, smooth, creamy milk chocolate as this confectionery favorite perfectly pairs with our single origin, low acid, medium roast specialty beans.<br><br>
  
        Breathing in the pleasantly sweet aroma as you brew will have you anxiously awaiting your first sip, and once you indulge, this classic, yet incredible, flavor combination will keep you coming back for more. 
      `
    },
    imageSrc: {
        type: String,
        default: "/assets/images/chocolate-covered.png"
    },
    imageAlt: {
        type: String,
        default: "Chocolate Covered Strawberry"
    },
    backgroundColor: {
        type: String,
        default: "white"
    }
});

defineBuilderComponent({
    friendlyName: "InfoWithFullLeftImage",
    inputs: [
        {
            name: "heading",
            type: "string",
            friendlyName: "Heading",
            defaultValue: "Chocolate Covered Strawberry"
        },
        {
            name: "description",
            type: "richText",
            friendlyName: "Description",
            defaultValue: `
          This Valentine's Day, fill your mug with our indulgent chocolate covered strawberry coffee and savor the taste and fragrance of heaven. <br><br>
  
          All natural extracts of sweet, sun-ripened, juicy strawberries come alive beneath a blanket of silky, smooth, creamy milk chocolate as this confectionery favorite perfectly pairs with our single origin, low acid, medium roast specialty beans.<br><br>
  
          Breathing in the pleasantly sweet aroma as you brew will have you anxiously awaiting your first sip, and once you indulge, this classic, yet incredible, flavor combination will keep you coming back for more. 
        `
        },
        {
            name: "imageSrc",
            type: "file",
            friendlyName: "Image Source",
            allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
            defaultValue: "/assets/images/chocolate-covered.png"
        },
        {
            name: "imageAlt",
            type: "string",
            friendlyName: "Image Alt Text",
            defaultValue: "Chocolate Covered Strawberry"
        },
        {
            name: "backgroundColor",
            type: "color",
            friendlyName: "Background Color",
            defaultValue: "white"
        }
    ]
});
</script>